import Select from "react-select";
import { useRouter } from "next/router";
import { FilterOptions } from "../../models/FilterOptions";
import {
  subjectPickerDropdownStyles,
  customStyles,
} from "../../util/sharedStyles";
import urlParameterController from "../../util/urlParameterController";

const getSelectedFilterValue = (
  filter: string,
  urlParameters: object,
  FilterOptions: Array<FilterOptions>
) => {
  const value = urlParameters[filter];
  const allFilterOption = {
    label: `All ${filter}s`,
    value: "",
  };
  if (!value) {
    return allFilterOption;
  }
  const filterOption: object = FilterOptions.filter(
    (options) => options.value === value
  ).map((filter) => ({
    label: filter.label,
    value: filter.value,
  }))[0];
  if (!filterOption) {
    return allFilterOption;
  } else {
    return filterOption;
  }
};

const DropdownIndicator = () => (
  // eslint-disable-next-line @next/next/no-img-element
  <img
    className="dropdown-image"
    src="/view-tutors/chevron-vertical-primary7.svg"
    alt="Dropdown icon"
  />
);

const PickerDropdown = ({ filter, FilterOptions, urlParameters }) => {
  const router = useRouter();
  const options = FilterOptions;
  options.unshift({
    label: `All ${filter}s`,
    value: "",
  });
  const ariaLabel: string = "Select " + filter;
  const placeHolder: string = "All " + filter + "s";
  const defaultOption = getSelectedFilterValue(
    filter,
    urlParameters,
    FilterOptions
  );
  return (
    <Select
      instanceId="subject-picker"
      css={subjectPickerDropdownStyles}
      styles={customStyles}
      components={{ DropdownIndicator }}
      options={FilterOptions}
      defaultValue={defaultOption}
      aria-label={ariaLabel}
      placeholder={placeHolder}
      onChange={(newValue: { label: string; value: string }) => {
        const sanitisedLabel = newValue.value
          .toLowerCase()
          .replaceAll("-", "_");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAevent",
          event_id: "14",
          eventCategory: "filter",
          eventAction: filter,
          eventLabel: sanitisedLabel,
        });
        const path = router.asPath;
        let newPath = urlParameterController(
          filter.toUpperCase(),
          newValue.value,
          path
        );
        newPath = urlParameterController("PAGINATION", "1", newPath); //Reset pagination to page=1
        router.push(newPath);
      }}
      menuPlacement="bottom"
    />
  );
};

export default PickerDropdown;
